module.exports = __webpack_public_path__ + "static/media/visa.fdabc70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/visa.png
// module id = 214
// module chunks = 0